module.exports = __webpack_public_path__ + "img/ship-addr-title.f229f2ac.png";